import { HIERARCHY_CATEGORIES_MAP } from 'pages/product-full-view/components/product-new-detail-view/constants';

export const getSubcategoriesByCategory = (category) => {
  if (!category || !HIERARCHY_CATEGORIES_MAP[category]) {
    return [];
  }
  return HIERARCHY_CATEGORIES_MAP[category].subcategories || [];
};

export const getClassesByCategoryAndSubcategory = (category, subcategory) => {
  if (!category || !subcategory || !HIERARCHY_CATEGORIES_MAP[category]) {
    return [];
  }

  const categoryData = HIERARCHY_CATEGORIES_MAP[category];

  if (!categoryData.classes || !categoryData.classes[subcategory]) {
    return [];
  }

  return categoryData.classes[subcategory];
};

export const isValidSubcategory = (category, subcategory) => {
  const subcategories = getSubcategoriesByCategory(category);
  return subcategories.includes(subcategory);
};

export const isValidClass = (category, subcategory, classValue) => {
  const classes = getClassesByCategoryAndSubcategory(category, subcategory);
  return classes.includes(classValue);
};
